/* ============================================================================
FILE: po-katupirsia9-couleur-matiere-texts-fr-en-es-20260318.js

MODE: TRILINGUE (FR/EN/ES) + protection lexicale stricte
API:  window.PoK9CouleurMatiereTextsFR_EN_ES_20260318
ROOT: .po-k9-section[data-po-k9]

RÔLE:
- injecte le contenu FR/EN/ES dans les slots data-po-slot
- conserve les termes du lexique canonique en FR, quelle que soit la langue
- verrouille la traduction automatique sur le bloc
- compat Shopify / multi-instances
- alias compat : window.GoodyTwinLang
============================================================================ */

(function () {
  "use strict";

  if (window.__PO_K9_COULEUR_MATIERE_TEXTS_20260318__) return;
  window.__PO_K9_COULEUR_MATIERE_TEXTS_20260318__ = true;
  window.__POLEX_RUNTIME_INIT__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";
  var ROOT_SEL = '.po-k9-section[data-po-k9="couleur_matiere"]';

  function clampStr(v) {
    return v == null ? "" : String(v);
  }

  function normLang(raw) {
    var v = clampStr(raw).toLowerCase().trim();
    if (v.indexOf("fr") === 0) return "fr";
    if (v.indexOf("en") === 0) return "en";
    if (v.indexOf("es") === 0) return "es";
    return "";
  }

  function readStoredLang() {
    try {
      var v = normLang(localStorage.getItem(STORAGE_KEY));
      if (v) return v;
    } catch (e) {}
    try {
      var v2 = normLang(localStorage.getItem(STORAGE_KEY_COMPAT));
      if (v2) return v2;
    } catch (e) {}
    return "";
  }

  function storeLang(lang) {
    var v = normLang(lang) || "fr";
    try { localStorage.setItem(STORAGE_KEY, v); } catch (e) {}
    try { localStorage.setItem(STORAGE_KEY_COMPAT, v); } catch (e) {}
  }

  function detectBrowserLang() {
    try {
      var n = (navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || "";
      var v = normLang(n);
      if (v) return v;
    } catch (e) {}
    return "fr";
  }

  function getLang() {
    return readStoredLang() || detectBrowserLang() || "fr";
  }

  function notifyLocaleChanged() {
    try {
      window.dispatchEvent(new Event("po:locale-changed"));
    } catch (e) {
      try {
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      } catch (_e) {}
    }
  }

  function escapeRegExp(s) {
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v) {
    if (!v) return;
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === v) return;
    }
    arr.push(v);
  }

  function buildVariants(term) {
    var out = [];
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t);
    uniqPush(out, t.replace(/’/g, "'"));
    uniqPush(out, t.replace(/'/g, "’"));
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"));
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"));

    return out;
  }

  function getSimplifiedLexiqueFRList() {
    try {
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)) {
        return window.PO_LEXICON_META.lexique_simplifie_fr.slice();
      }
    } catch (e) {}

    return [
      "Posœnnoïa",
      "Posœnnoïsme",
      "Àṣẹxel’Or",
      "Âṣẹxel’Or",
      "Couleur-Temps",
      "Couleur-Espace",
      "Couleur-Matière",
      "Triade Chromatique",
      "Triade Chromatique Posœnnoïale",
      "Sceau d’Équiphase",
      "Sceau de Syntonie",
      "Katûvýs",
      "Katûvýsissence",
      "Isqun",
      "Threnisqun",
      "Ennéagone",
      "Balakallpa",
      "Numéris",
      "Année posœnnoïale",
      "Année posœnnoïale (AP)",
      "Épagomènes",
      "Méditations Posœnnoïales",
      "Accords Posœnnoïaux",
      "Δτ",
      "Φ₄₉₂",
      "ρₘ",
      "492 Hz",
      "K9",
      "AP",
      "Uniforme",
      "Lissé",
      "Pulsé",
      "Ēkuphasa",
      "Syntōnēa",
      "Aísthēra",
      "Anēporon",
      "Ifẹ̀riya",
      "Ayeẹmīnê",
      "Ọ̀rōyuyān",
      "Yuyarīnâ",
      "Œndomarê",
      "Éther",
      "Air",
      "Feu",
      "Eau",
      "Terre"
    ];
  }

  function buildProtectMatcher() {
    var base = getSimplifiedLexiqueFRList();
    var variants = [];

    for (var i = 0; i < base.length; i++) {
      var list = buildVariants(base[i]);
      for (var j = 0; j < list.length; j++) uniqPush(variants, list[j]);
    }

    variants.sort(function (a, b) { return b.length - a.length; });

    var parts = [];
    for (var k = 0; k < variants.length; k++) {
      parts.push(escapeRegExp(variants[k]));
    }

    return new RegExp(parts.join("|"), "g");
  }

  function protectLexiconInHTML(html) {
    var src = clampStr(html);
    if (!src) return "";

    var rx = buildProtectMatcher();
    return src.replace(rx, function (m) {
      return '<span translate="no" class="po-lex-protect">' + m + "</span>";
    });
  }

  function setHTML(el, html) {
    if (!el) return;
    el.innerHTML = protectLexiconInHTML(html);
  }

  function setText(el, txt) {
    if (!el) return;
    el.textContent = clampStr(txt);
  }

  function setImg(el, data) {
    if (!el) return;

    var src = data && data.src ? data.src : "";
    var alt = data && data.alt ? data.alt : "";
    var media = el.parentElement || null;

    if (src) {
      el.src = src;
      el.alt = alt;
      el.removeAttribute("hidden");
      if (media) media.removeAttribute("hidden");
    } else {
      el.removeAttribute("src");
      el.setAttribute("alt", "");
      el.setAttribute("hidden", "");
      if (media) media.setAttribute("hidden", "");
    }
  }

  var CONTENT = {
    fr: {
      title: "Couleur-Matière",
      kicker: "Troisième porte de la Triade Chromatique Posœnnoïale — la mémoire du souffle, là où la lumière devient trace, densité et réactivation.",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_conceptuel.png?v=1773257633",
        alt: "Idéogramme conceptuel de Couleur-Matière"
      },

      h_def: "Définition canonique",

      chip_1: "Idéogramme conceptuel",
      chip_1_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_conceptuel.png?v=1773257633",
        alt: "Idéogramme conceptuel de Couleur-Matière"
      },

      chip_2: "Idéogramme fonctionnel",
      chip_2_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_fonctionnel.png?v=1773257633",
        alt: "Idéogramme fonctionnel de Couleur-Matière"
      },

      def_short:
        "<strong>Couleur-Matière</strong> désigne la manière dont la couleur se donne comme mémoire active, densité et trace de lumière : non simple surface colorée, mais lieu de retenue, de transformation et de réactivation, dans la continuité de la <strong>Katûvýsissence</strong>, sous l’ajustement de l’<strong>Isqun</strong> et la mémoire opérante du <strong>Threnisqun</strong>.",

      def_long:
        "<p>Dans la Triade Chromatique Posœnnoïale, <strong>Couleur-Matière</strong> constitue la porte de mémoire : la couleur n’y apparaît pas comme ajout décoratif, mais comme résultat d’une interaction, d’un passage et d’une conversion.</p>" +
        "<p>Chaque pigment, chaque surface, chaque texture agit comme lieu de retenue. La lumière y est absorbée, transformée, partiellement restituée. Ce qui se donne alors n’est pas la lumière elle-même, mais ce que la matière en a gardé, modifié et rendu à nouveau perceptible.</p>" +
        "<p><strong>Couleur-Matière</strong> ne forme pourtant pas un domaine isolé. Ce que la matière retient garde la mémoire de <strong>Couleur-Temps</strong> et la trace des propagations de <strong>Couleur-Espace</strong>. La couleur y devient mémoire en cours d’activation.</p>",

      h_grid: "Structure vibratoire",
      grid_type_label: "Type",
      grid_type_value: "Troisième porte chromatique du K9 : densité / mémoire, stabilisation et réactivation du passage lumineux",
      grid_freq_label: "Valeurs-clés",
      grid_freq_value: "Katûvýsissence : substrat-mémoire · Isqun : redistribution perceptive · Threnisqun : mémoire spiralée active · ρₘ : densité mémorielle · Δτ : persistance opérative",
      grid_scope_label: "Axes et déploiement",
      grid_scope_value:
        "<ul>" +
        "<li>Champ de référence : <strong>Katûvýsissence</strong></li>" +
        "<li>Mouvement : rétention, transformation, restitution partielle</li>" +
        "<li>Régulations actives : <strong>Isqun</strong> ajuste ; <strong>Threnisqun</strong> retient et réactive</li>" +
        "<li>Profils lisibles : <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li>Formule opérative : <strong>la lumière devient trace</strong></li>" +
        "</ul>",

      h_intro: "La mémoire du passage",
      p_intro:
        "<p>Dans l’expérience posœnnoïale, la matière ne se donne jamais comme simple support. Elle apparaît comme ce qui retient, ce qui transforme, ce qui garde en tension ce qui l’a traversée.</p>" +
        "<p>La couleur, lorsqu’elle se manifeste dans la matière, n’est pas un revêtement ajouté. Elle est l’indice d’une histoire de passage, d’un échange entre lumière, densité, temps et mémoire.</p>" +
        "<p><strong>Couleur-Matière</strong> formalise ainsi une persistance : le visible y devient archive active, rémanence respirante, mémoire rendue perceptible.</p>",

      h_actions: "Fonctionnement opératif",
      actions:
        "<ol>" +
        "<li>Approcher la matière comme lieu de mémoire, jamais comme simple support passif.</li>" +
        "<li>Observer comment la couleur y est retenue, transformée, diffusée ou réémise selon la densité du support.</li>" +
        "<li>Reconnaître l’action du <strong>Threnisqun</strong> dans la capacité de la matière à conserver et réactiver ce qu’elle a reçu.</li>" +
        "<li>Rapporter l’ajustement perceptif à l’<strong>Isqun</strong>, qui évite la saturation et maintient la lisibilité du champ.</li>" +
        "<li>Relier cette mémoire dense au battement de <strong>Couleur-Temps</strong> et aux propagations de <strong>Couleur-Espace</strong>.</li>" +
        "</ol>",

      h_phrase: "Phrase opérative",
      phrase:
        "« Couleur-Matière : la couleur n’y recouvre pas la matière, elle y réactive la mémoire du passage lumineux. »",

      h_table: "Tableau d’usage",
      table_head_1: "Profil",
      table_head_2: "Climat chromatique",
      table_head_3: "Régime et manifestation",
      table_rows:
        "<tr><td><strong>Uniforme</strong></td><td>ocres tenus, verts équilibrés, gris épais, mémoires stables</td><td>Fixation, retenue, assise matérielle ; inscription durable ; ancrage du visible dans une densité respirable</td></tr>" +
        "<tr><td><strong>Lissé</strong></td><td>bleus diffus, turquoises, iridescences, transparences retenues</td><td>Diffusion dans la matière ; imprégnation, circulation douce, restitution partielle ; mémoire ouverte et fluide</td></tr>" +
        "<tr><td><strong>Pulsé</strong></td><td>rouges denses, ors, charbons lumineux, tensions de seuil</td><td>Condensation, réémission intense, foyer de réactivation ; retour du souffle dans une densité accentuée</td></tr>",

      h_entite: "Position dans la triade",
      entite_kicker: "Matière — mémoire — troisième porte",
      entite_body:
        "<p>Dans la Triade Chromatique Posœnnoïale, <strong>Couleur-Matière</strong> correspond à la mémoire. Elle recueille ce qui a battu dans <strong>Couleur-Temps</strong> et ce qui s’est propagé dans <strong>Couleur-Espace</strong>.</p>" +
        "<p>Son champ de référence est la <strong>Katûvýsissence</strong>, où la lumière retenue devient trace, texture, opacité, translucidité, rémanence. L’<strong>Isqun</strong> en module la lisibilité ; le <strong>Threnisqun</strong> en maintient la mémoire active.</p>" +
        "<p>Ainsi, la matière cesse d’être inertie. Elle devient archive respirante, mémoire dense, lieu de réactivation du visible.</p>",

      h_ritual: "Rituel d’activation",
      ritual_name_label: "Nom",
      ritual_name_value: "Lecture de la mémoire matérielle",
      ritual_steps:
        "<ol>" +
        "<li>Se placer devant une surface, une œuvre, un pigment, une texture ou une matière colorée, sans réduire d’emblée ce qui apparaît à une simple teinte.</li>" +
        "<li>Repérer les signes de retenue, d’épaisseur, de translucidité, de diffusion ou de restitution.</li>" +
        "<li>Reconnaître si la matière tend vers un profil <strong>Uniforme</strong>, <strong>Lissé</strong> ou <strong>Pulsé</strong>.</li>" +
        "<li>Laisser la couleur fonctionner comme mémoire active du passage, et non comme surface morte.</li>" +
        "<li>Clore par la phrase opérative afin de restituer à la matière sa respiration, sa densité et sa fonction de souvenir.</li>" +
        "</ol>",

      h_moments: "Moments privilégiés",
      moments:
        "<ul>" +
        "<li>Quand une surface semble garder plus qu’elle ne montre immédiatement</li>" +
        "<li>Dans les œuvres où texture, transparence, opacité et grain deviennent mémoire sensible</li>" +
        "<li>Dans la fréquentation des pigments, des métaux, des fibres, des sols, des peaux et des matières traversées par la lumière</li>" +
        "<li>Aux seuils où la matière restitue soudain une intensité retenue</li>" +
        "<li>Quand la couleur agit comme survivance du passage et non comme revêtement fermé</li>" +
        "</ul>",

      h_syntony: "Syntonies K9",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýsissence</strong> — substrat-mémoire, rétention active du passage lumineux</li>" +
        "<li><strong>Threnisqun</strong> — conservation et réactivation des états traversés</li>" +
        "<li><strong>Isqun</strong> — redistribution perceptive, évitement de la saturation, maintien de la cohérence</li>" +
        "<li><strong>Δτ</strong> — persistance opérative de ce qui, du temps, demeure actif dans la matière</li>" +
        "<li><strong>Couleur-Temps</strong> — pulsation dont la matière garde le battement différé</li>" +
        "<li><strong>Couleur-Espace</strong> — propagation dont la matière recueille et densifie les traces</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: "Couleur-Matière",
      kicker: "Third gate of the Triade Chromatique Posœnnoïale — the memory of breath, where light becomes trace, density, and reactivation.",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_conceptuel.png?v=1773257633",
        alt: "Conceptual ideogram of Couleur-Matière"
      },

      h_def: "Canonical definition",

      chip_1: "Conceptual ideogram",
      chip_1_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_conceptuel.png?v=1773257633",
        alt: "Conceptual ideogram of Couleur-Matière"
      },

      chip_2: "Functional ideogram",
      chip_2_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_fonctionnel.png?v=1773257633",
        alt: "Functional ideogram of Couleur-Matière"
      },

      def_short:
        "<strong>Couleur-Matière</strong> designates the way color is given as active memory, density, and trace of light: not a simple colored surface, but a place of retention, transformation, and reactivation, within the continuity of <strong>Katûvýsissence</strong>, under the adjustment of <strong>Isqun</strong> and the operative memory of <strong>Threnisqun</strong>.",

      def_long:
        "<p>Within the Triade Chromatique Posœnnoïale, <strong>Couleur-Matière</strong> constitutes the gate of memory: color does not appear there as a decorative addition, but as the result of an interaction, a passage, and a conversion.</p>" +
        "<p>Each pigment, each surface, each texture acts as a place of retention. Light is absorbed, transformed, and partially restored there. What is then given is not light itself, but what matter has kept of it, altered, and made perceptible again.</p>" +
        "<p><strong>Couleur-Matière</strong> does not, however, form an isolated domain. What matter retains keeps the memory of <strong>Couleur-Temps</strong> and the trace of the propagations of <strong>Couleur-Espace</strong>. Color there becomes memory in the process of activation.</p>",

      h_grid: "Vibratory structure",
      grid_type_label: "Type",
      grid_type_value: "Third chromatic gate of K9: density / memory, stabilization and reactivation of the luminous passage",
      grid_freq_label: "Key values",
      grid_freq_value: "Katûvýsissence: substrate-memory · Isqun: perceptive redistribution · Threnisqun: active spiral memory · ρₘ: memorial density · Δτ: operative persistence",
      grid_scope_label: "Axes and deployment",
      grid_scope_value:
        "<ul>" +
        "<li>Reference field: <strong>Katûvýsissence</strong></li>" +
        "<li>Movement: retention, transformation, partial restitution</li>" +
        "<li>Active regulations: <strong>Isqun</strong> adjusts; <strong>Threnisqun</strong> retains and reactivates</li>" +
        "<li>Readable profiles: <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li>Operative formula: <strong>light becomes trace</strong></li>" +
        "</ul>",

      h_intro: "The memory of passage",
      p_intro:
        "<p>In posœnnoïal experience, matter is never given as a simple support. It appears as what retains, what transforms, what keeps in tension what has passed through it.</p>" +
        "<p>Color, when it manifests in matter, is not an added coating. It is the sign of a history of passage, of an exchange between light, density, time, and memory.</p>" +
        "<p><strong>Couleur-Matière</strong> thus formalizes a persistence: the visible there becomes an active archive, a breathing remanence, memory made perceptible.</p>",

      h_actions: "Operative functioning",
      actions:
        "<ol>" +
        "<li>Approach matter as a place of memory, never as a merely passive support.</li>" +
        "<li>Observe how color is retained, transformed, diffused, or re-emitted there according to the density of the support.</li>" +
        "<li>Recognize the action of <strong>Threnisqun</strong> in matter’s capacity to conserve and reactivate what it has received.</li>" +
        "<li>Relate perceptive adjustment to <strong>Isqun</strong>, which avoids saturation and maintains the field’s readability.</li>" +
        "<li>Connect this dense memory to the beat of <strong>Couleur-Temps</strong> and to the propagations of <strong>Couleur-Espace</strong>.</li>" +
        "</ol>",

      h_phrase: "Operative phrase",
      phrase:
        "“Couleur-Matière: color does not cover matter there, it reactivates the memory of the luminous passage within it.”",

      h_table: "Usage table",
      table_head_1: "Profile",
      table_head_2: "Chromatic climate",
      table_head_3: "Regime and manifestation",
      table_rows:
        "<tr><td><strong>Uniforme</strong></td><td>held ochres, balanced greens, thick greys, stable memories</td><td>Fixation, retention, material grounding; durable inscription; anchoring of the visible within a breathable density</td></tr>" +
        "<tr><td><strong>Lissé</strong></td><td>diffused blues, turquoises, iridescences, retained transparencies</td><td>Diffusion in matter; impregnation, gentle circulation, partial restitution; open and fluid memory</td></tr>" +
        "<tr><td><strong>Pulsé</strong></td><td>dense reds, golds, luminous charcoals, threshold tensions</td><td>Condensation, intense re-emission, center of reactivation; return of breath in an accentuated density</td></tr>",

      h_entite: "Position in the triad",
      entite_kicker: "Matter — memory — third gate",
      entite_body:
        "<p>Within the Triade Chromatique Posœnnoïale, <strong>Couleur-Matière</strong> corresponds to memory. It gathers what has beaten within <strong>Couleur-Temps</strong> and what has propagated within <strong>Couleur-Espace</strong>.</p>" +
        "<p>Its reference field is <strong>Katûvýsissence</strong>, where retained light becomes trace, texture, opacity, translucency, remanence. <strong>Isqun</strong> modulates its readability; <strong>Threnisqun</strong> maintains its active memory.</p>" +
        "<p>Thus matter ceases to be inertia. It becomes a breathing archive, dense memory, a place of reactivation of the visible.</p>",

      h_ritual: "Activation ritual",
      ritual_name_label: "Name",
      ritual_name_value: "Reading material memory",
      ritual_steps:
        "<ol>" +
        "<li>Stand before a surface, an artwork, a pigment, a texture, or a colored material, without reducing what appears at once to a simple hue.</li>" +
        "<li>Identify signs of retention, thickness, translucency, diffusion, or restitution.</li>" +
        "<li>Recognize whether matter tends toward a <strong>Uniforme</strong>, <strong>Lissé</strong>, or <strong>Pulsé</strong> profile.</li>" +
        "<li>Let color function as the active memory of passage, rather than as a dead surface.</li>" +
        "<li>Close with the operative phrase so that matter may recover its breath, density, and function of remembrance.</li>" +
        "</ol>",

      h_moments: "Privileged moments",
      moments:
        "<ul>" +
        "<li>When a surface seems to keep more than it immediately shows</li>" +
        "<li>In works where texture, transparency, opacity, and grain become sensible memory</li>" +
        "<li>In the frequentation of pigments, metals, fibers, soils, skins, and materials traversed by light</li>" +
        "<li>At thresholds where matter suddenly restores a retained intensity</li>" +
        "<li>When color acts as the survival of passage rather than as a closed coating</li>" +
        "</ul>",

      h_syntony: "Syntonies K9",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýsissence</strong> — substrate-memory, active retention of the luminous passage</li>" +
        "<li><strong>Threnisqun</strong> — conservation and reactivation of traversed states</li>" +
        "<li><strong>Isqun</strong> — perceptive redistribution, avoidance of saturation, maintenance of coherence</li>" +
        "<li><strong>Δτ</strong> — operative persistence of what, from time, remains active in matter</li>" +
        "<li><strong>Couleur-Temps</strong> — pulsation whose deferred beat matter keeps</li>" +
        "<li><strong>Couleur-Espace</strong> — propagation whose traces matter gathers and densifies</li>" +
        "</ul>",

      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: "Couleur-Matière",
      kicker: "Tercera puerta de la Triade Chromatique Posœnnoïale — la memoria del aliento, donde la luz se vuelve huella, densidad y reactivación.",
      title_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_conceptuel.png?v=1773257633",
        alt: "Ideograma conceptual de Couleur-Matière"
      },

      h_def: "Definición canónica",

      chip_1: "Ideograma conceptual",
      chip_1_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_conceptuel.png?v=1773257633",
        alt: "Ideograma conceptual de Couleur-Matière"
      },

      chip_2: "Ideograma funcional",
      chip_2_img: {
        src: "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Couleur-matiere_fonctionnel.png?v=1773257633",
        alt: "Ideograma funcional de Couleur-Matière"
      },

      def_short:
        "<strong>Couleur-Matière</strong> designa la manera en que el color se da como memoria activa, densidad y huella de luz: no simple superficie coloreada, sino lugar de retención, transformación y reactivación, en la continuidad de la <strong>Katûvýsissence</strong>, bajo el ajuste del <strong>Isqun</strong> y la memoria operante del <strong>Threnisqun</strong>.",

      def_long:
        "<p>En la Triade Chromatique Posœnnoïale, <strong>Couleur-Matière</strong> constituye la puerta de la memoria: el color no aparece allí como añadido decorativo, sino como resultado de una interacción, de un paso y de una conversión.</p>" +
        "<p>Cada pigmento, cada superficie, cada textura actúa como lugar de retención. La luz es absorbida, transformada y parcialmente restituida allí. Lo que se da entonces no es la luz misma, sino lo que la materia ha guardado de ella, modificado y vuelto perceptible.</p>" +
        "<p><strong>Couleur-Matière</strong> no forma, sin embargo, un dominio aislado. Lo que la materia retiene guarda la memoria de <strong>Couleur-Temps</strong> y la huella de las propagaciones de <strong>Couleur-Espace</strong>. El color se vuelve allí memoria en proceso de activación.</p>",

      h_grid: "Estructura vibratoria",
      grid_type_label: "Tipo",
      grid_type_value: "Tercera puerta cromática del K9: densidad / memoria, estabilización y reactivación del paso luminoso",
      grid_freq_label: "Valores clave",
      grid_freq_value: "Katûvýsissence: sustrato-memoria · Isqun: redistribución perceptiva · Threnisqun: memoria espiral activa · ρₘ: densidad memorial · Δτ: persistencia operativa",
      grid_scope_label: "Ejes y despliegue",
      grid_scope_value:
        "<ul>" +
        "<li>Campo de referencia: <strong>Katûvýsissence</strong></li>" +
        "<li>Movimiento: retención, transformación, restitución parcial</li>" +
        "<li>Regulaciones activas: <strong>Isqun</strong> ajusta; <strong>Threnisqun</strong> retiene y reactiva</li>" +
        "<li>Perfiles legibles: <strong>Uniforme</strong>, <strong>Lissé</strong>, <strong>Pulsé</strong></li>" +
        "<li>Fórmula operativa: <strong>la luz se vuelve huella</strong></li>" +
        "</ul>",

      h_intro: "La memoria del paso",
      p_intro:
        "<p>En la experiencia posœnnoïale, la materia nunca se da como simple soporte. Aparece como lo que retiene, lo que transforma, lo que guarda en tensión aquello que la ha atravesado.</p>" +
        "<p>El color, cuando se manifiesta en la materia, no es un revestimiento añadido. Es el indicio de una historia de paso, de un intercambio entre luz, densidad, tiempo y memoria.</p>" +
        "<p><strong>Couleur-Matière</strong> formaliza así una persistencia: lo visible se vuelve allí archivo activo, remanencia respirante, memoria hecha perceptible.</p>",

      h_actions: "Funcionamiento operativo",
      actions:
        "<ol>" +
        "<li>Aproximarse a la materia como lugar de memoria, nunca como simple soporte pasivo.</li>" +
        "<li>Observar cómo el color es retenido, transformado, difundido o reemitido allí según la densidad del soporte.</li>" +
        "<li>Reconocer la acción del <strong>Threnisqun</strong> en la capacidad de la materia para conservar y reactivar lo que ha recibido.</li>" +
        "<li>Relacionar el ajuste perceptivo con el <strong>Isqun</strong>, que evita la saturación y mantiene la legibilidad del campo.</li>" +
        "<li>Vincular esta memoria densa con el latido de <strong>Couleur-Temps</strong> y con las propagaciones de <strong>Couleur-Espace</strong>.</li>" +
        "</ol>",

      h_phrase: "Frase operativa",
      phrase:
        "« Couleur-Matière: el color no recubre la materia, reactiva en ella la memoria del paso luminoso. »",

      h_table: "Tabla de uso",
      table_head_1: "Perfil",
      table_head_2: "Clima cromático",
      table_head_3: "Régimen y manifestación",
      table_rows:
        "<tr><td><strong>Uniforme</strong></td><td>ocres sostenidos, verdes equilibrados, grises espesos, memorias estables</td><td>Fijación, retención, asiento material; inscripción duradera; anclaje de lo visible en una densidad respirable</td></tr>" +
        "<tr><td><strong>Lissé</strong></td><td>azules difusos, turquesas, iridiscencias, transparencias retenidas</td><td>Difusión en la materia; impregnación, circulación suave, restitución parcial; memoria abierta y fluida</td></tr>" +
        "<tr><td><strong>Pulsé</strong></td><td>rojos densos, oros, carbones luminosos, tensiones de umbral</td><td>Condensación, reemisión intensa, foco de reactivación; retorno del aliento en una densidad acentuada</td></tr>",

      h_entite: "Posición en la tríada",
      entite_kicker: "Materia — memoria — tercera puerta",
      entite_body:
        "<p>En la Triade Chromatique Posœnnoïale, <strong>Couleur-Matière</strong> corresponde a la memoria. Recoge lo que ha latido en <strong>Couleur-Temps</strong> y lo que se ha propagado en <strong>Couleur-Espace</strong>.</p>" +
        "<p>Su campo de referencia es la <strong>Katûvýsissence</strong>, donde la luz retenida se vuelve huella, textura, opacidad, translucidez, remanencia. El <strong>Isqun</strong> modula su legibilidad; el <strong>Threnisqun</strong> mantiene su memoria activa.</p>" +
        "<p>Así, la materia deja de ser inercia. Se vuelve archivo respirante, memoria densa, lugar de reactivación de lo visible.</p>",

      h_ritual: "Ritual de activación",
      ritual_name_label: "Nombre",
      ritual_name_value: "Lectura de la memoria material",
      ritual_steps:
        "<ol>" +
        "<li>Situarse ante una superficie, una obra, un pigmento, una textura o una materia coloreada, sin reducir de inmediato lo que aparece a un simple tono.</li>" +
        "<li>Identificar signos de retención, espesor, translucidez, difusión o restitución.</li>" +
        "<li>Reconocer si la materia tiende hacia un perfil <strong>Uniforme</strong>, <strong>Lissé</strong> o <strong>Pulsé</strong>.</li>" +
        "<li>Dejar que el color funcione como memoria activa del paso, y no como superficie muerta.</li>" +
        "<li>Cerrar con la frase operativa para devolver a la materia su respiración, su densidad y su función de recuerdo.</li>" +
        "</ol>",

      h_moments: "Momentos privilegiados",
      moments:
        "<ul>" +
        "<li>Cuando una superficie parece guardar más de lo que muestra de inmediato</li>" +
        "<li>En obras donde textura, transparencia, opacidad y grano se vuelven memoria sensible</li>" +
        "<li>En la frecuentación de pigmentos, metales, fibras, suelos, pieles y materias atravesadas por la luz</li>" +
        "<li>En los umbrales donde la materia restituye de pronto una intensidad retenida</li>" +
        "<li>Cuando el color actúa como supervivencia del paso y no como revestimiento cerrado</li>" +
        "</ul>",

      h_syntony: "Sintonías K9",
      syntony:
        "<ul>" +
        "<li><strong>Katûvýsissence</strong> — sustrato-memoria, retención activa del paso luminoso</li>" +
        "<li><strong>Threnisqun</strong> — conservación y reactivación de los estados atravesados</li>" +
        "<li><strong>Isqun</strong> — redistribución perceptiva, evitación de la saturación, mantenimiento de la coherencia</li>" +
        "<li><strong>Δτ</strong> — persistencia operativa de lo que, del tiempo, permanece activo en la materia</li>" +
        "<li><strong>Couleur-Temps</strong> — pulsación cuyo latido diferido la materia guarda</li>" +
        "<li><strong>Couleur-Espace</strong> — propagación cuyas huellas la materia recoge y densifica</li>" +
        "</ul>",

      cta_translate: "Proposer une traduction du concept"
    }
  };

  function syncDocumentLang(lang) {
    try {
      document.documentElement.setAttribute("lang", lang || "fr");
    } catch (e) {}
  }

  function applyLangbar(root, lang) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      var active = buttons[i].getAttribute("data-po-lang") === lang;
      buttons[i].setAttribute("aria-pressed", active ? "true" : "false");
      if (active) buttons[i].classList.add("is-active");
      else buttons[i].classList.remove("is-active");
    }
  }

  /* ========================================================================
     AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
  ======================================================================== */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;
  var PO_AUDIO_STATE = { root:null, units:[], unitPos:-1, chunks:[], chunkPos:-1, activeKey:"", lang:"fr", voice:null };
  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    return AUDIO_UI[normLang(lang) || "fr"] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-k9-couleur-matiere-audio-styles")) return;
    var st = document.createElement("style");
    st.id = "po-k9-couleur-matiere-audio-styles";
    st.textContent = '' +
      '.po-axis-audio-wrap{display:flex;justify-content:center;align-items:center;margin:10px 0 12px;}' +
      '.po-axis-audio-btn{appearance:none;border:1px solid rgba(184,134,11,.40);background:rgba(255,255,255,.72);color:inherit;border-radius:999px;padding:8px 12px;font:inherit;font-size:12px;line-height:1.2;font-weight:700;cursor:pointer;box-shadow:0 3px 12px rgba(0,0,0,.05);}' +
      '.po-axis-audio-btn[data-po-audio-active="true"]{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.18),0 8px 18px rgba(31,122,58,.14);}' +
      '.po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;}' +
      '.po-lex-summary .po-lex-summary__title{margin-right:auto;}' +
      '@media (max-width:760px){.po-axis-audio-btn{font-size:11px;padding:7px 10px;}}';
    document.head.appendChild(st);
  }

  function stopAudio(){
    if (PO_AUDIO_SYNTH) {
      try { PO_AUDIO_SYNTH.cancel(); } catch (e) {}
    }
    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.voice = null;
    refreshAudioButtonsEverywhere(getLang());
  }

  function pickVoice(lang){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_SYNTH.getVoices) return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var pref = normLang(lang) || "fr";
    var rx = pref === "es" ? /^es/i : pref === "en" ? /^en/i : /^fr/i;
    for (var i=0;i<voices.length;i++) {
      var lc = clampStr(voices[i].lang || "");
      if (rx.test(lc)) return voices[i];
    }
    return voices[0] || null;
  }

  function splitForSpeech(text){
    var src = clampStr(text).replace(/\s+/g, " ").trim();
    if (!src) return [];
    var parts = src.match(/[^.!?;:]+[.!?;:]?|[^.!?;:]+$/g) || [src];
    var out = [];
    var maxLen = 210;
    for (var i=0;i<parts.length;i++) {
      var p = clampStr(parts[i]).trim();
      if (!p) continue;
      while (p.length > maxLen) {
        var cut = p.lastIndexOf(" ", maxLen);
        if (cut < 80) cut = maxLen;
        out.push(p.slice(0, cut).trim());
        p = p.slice(cut).trim();
      }
      if (p) out.push(p);
    }
    return out;
  }

  function cleanClone(node){
    if (!node || !node.cloneNode) return null;
    var clone = node.cloneNode(true);
    var bad = clone.querySelectorAll('script,style,.po-axis-audio-wrap,.po-axis-audio-btn,[hidden],[aria-hidden="true"]');
    for (var i=0;i<bad.length;i++) {
      if (bad[i] && bad[i].parentNode) bad[i].parentNode.removeChild(bad[i]);
    }
    return clone;
  }

  function extractText(node){
    var clone = cleanClone(node);
    if (!clone) return "";
    var txt = clampStr(clone.textContent || clone.innerText || "");
    return txt.replace(/\s+/g, " ").trim();
  }

  function collectGeneralText(root){
    var parts = [];
    var slots = ["title","kicker","h_def","def_short","def_long"];
    for (var i=0;i<slots.length;i++) {
      var el = root.querySelector('[data-po-slot="' + slots[i] + '"]');
      var txt = extractText(el);
      if (txt) parts.push(txt);
    }
    return parts.join(" ");
  }

  function collectBlockText(details){
    if (!details) return "";
    var title = extractText(details.querySelector('.po-lex-summary__title'));
    var contentParts = [];
    var nodes = details.querySelectorAll('.po-axis-wb,.po-lex-example,.po-lex-table,.po-lex-list');
    for (var i=0;i<nodes.length;i++) {
      var txt = extractText(nodes[i]);
      if (txt) contentParts.push(txt);
    }
    return (title ? title + ' ' : '') + contentParts.join(' ');
  }

  function buildUnits(root, startBlockIndex, includeGeneral){
    var units = [];
    if (includeGeneral) {
      var general = collectGeneralText(root);
      if (general) units.push({ key:'general', text:general, details:null });
    }
    var details = root.querySelectorAll('.po-lex-details');
    for (var i = startBlockIndex || 0; i < details.length; i++) {
      var txt = collectBlockText(details[i]);
      if (txt) units.push({ key:'block-' + i, text:txt, details:details[i] });
    }
    return units;
  }

  function setDetailsOpen(details, open){
    if (!details) return;
    try { details.open = !!open; } catch (e) {
      if (open) details.setAttribute('open','');
      else details.removeAttribute('open');
    }
  }

  function refreshAudioButtons(root, lang){
    if (!root) return;
    var ui = audioUI(lang);
    var btns = root.querySelectorAll('.po-axis-audio-btn');
    for (var i=0;i<btns.length;i++) {
      var btn = btns[i];
      var role = btn.getAttribute('data-po-audio-role') || 'block';
      var active = (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === btn.getAttribute('data-po-audio-key'));
      btn.setAttribute('data-po-audio-active', active ? 'true' : 'false');
      btn.textContent = active ? ui.stop : (role === 'general' ? ui.general : ui.block);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    }
  }

  function refreshAudioButtonsEverywhere(lang){
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++) refreshAudioButtons(roots[i], lang);
  }

  function ensureAudioButtons(root){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector('.po-lex-panel');
    if (panel && !root.querySelector('.po-axis-audio-wrap[data-po-audio-role="general"]')) {
      var wrap = document.createElement('div');
      wrap.className = 'po-axis-audio-wrap';
      wrap.setAttribute('data-po-audio-role','general');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'po-axis-audio-btn';
      btn.setAttribute('data-po-audio-role','general');
      btn.setAttribute('data-po-audio-key','general');
      wrap.appendChild(btn);

      var meta = root.querySelector('.po-axis-meta');
      var defShort = root.querySelector('[data-po-slot="def_short"]');
      if (meta && meta.parentNode) {
        if (meta.nextSibling) meta.parentNode.insertBefore(wrap, meta.nextSibling);
        else meta.parentNode.appendChild(wrap);
      } else if (defShort && defShort.parentNode) {
        defShort.parentNode.insertBefore(wrap, defShort);
      } else {
        panel.insertBefore(wrap, panel.firstChild || null);
      }

      btn.addEventListener('click', function(){
        if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === 'general') stopAudio();
        else startAudio(root, null, true);
      });
    }

    var details = root.querySelectorAll('.po-lex-details');
    for (var i=0;i<details.length;i++) {
      var summary = details[i].querySelector('.po-lex-summary');
      if (!summary || summary.querySelector('.po-axis-audio-btn[data-po-audio-role="block"]')) continue;
      var btn2 = document.createElement('button');
      btn2.type = 'button';
      btn2.className = 'po-axis-audio-btn';
      btn2.setAttribute('data-po-audio-role','block');
      btn2.setAttribute('data-po-audio-key','block-' + i);
      btn2.addEventListener('click', (function(index){
        return function(ev){
          try { ev.preventDefault(); ev.stopPropagation(); } catch(e) {}
          if (PO_AUDIO_STATE.root === root && PO_AUDIO_STATE.activeKey === ('block-' + index)) stopAudio();
          else startAudio(root, index, false);
        };
      })(i));
      summary.appendChild(btn2);
    }

    refreshAudioButtons(root, getLang());
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH) {
      stopAudio();
      return;
    }

    if (!PO_AUDIO_STATE.chunks.length || PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length) {
      advanceUnit();
      return;
    }

    var text = PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos];
    if (!text) {
      PO_AUDIO_STATE.chunkPos += 1;
      speakNextChunk();
      return;
    }

    var utter = new SpeechSynthesisUtterance(text);
    utter.lang = (normLang(PO_AUDIO_STATE.lang) || 'fr') + '-' + (normLang(PO_AUDIO_STATE.lang) || 'fr').toUpperCase();
    var voice = PO_AUDIO_STATE.voice || pickVoice(PO_AUDIO_STATE.lang);
    if (voice) utter.voice = voice;
    utter.onend = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakNextChunk();
    };
    utter.onerror = function(){
      PO_AUDIO_STATE.chunkPos += 1;
      speakNextChunk();
    };

    try {
      PO_AUDIO_SYNTH.cancel();
      PO_AUDIO_SYNTH.speak(utter);
    } catch (e) {
      stopAudio();
    }
  }

  function advanceUnit(){
    PO_AUDIO_STATE.unitPos += 1;
    if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length) {
      stopAudio();
      return;
    }

    var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
    PO_AUDIO_STATE.activeKey = unit.key;
    if (unit.details) setDetailsOpen(unit.details, true);
    PO_AUDIO_STATE.chunks = splitForSpeech(unit.text);
    PO_AUDIO_STATE.chunkPos = 0;
    refreshAudioButtons(PO_AUDIO_STATE.root, PO_AUDIO_STATE.lang);
    speakNextChunk();
  }

  function startAudio(root, blockIndex, includeGeneral){
    if (!root) return;
    if (!PO_AUDIO_SYNTH) return;
    stopAudio();
    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.lang = getLang();
    PO_AUDIO_STATE.voice = pickVoice(PO_AUDIO_STATE.lang);
    PO_AUDIO_STATE.units = buildUnits(root, blockIndex || 0, !!includeGeneral);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.activeKey = includeGeneral ? 'general' : ('block-' + (blockIndex || 0));
    refreshAudioButtons(root, PO_AUDIO_STATE.lang);
    advanceUnit();
  }

  function initAudioEverywhere(lang){
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++) ensureAudioButtons(roots[i]);
    refreshAudioButtonsEverywhere(lang || getLang());
  }

  try {
    if (PO_AUDIO_SYNTH && PO_AUDIO_SYNTH.onvoiceschanged !== undefined) {
      PO_AUDIO_SYNTH.onvoiceschanged = function(){ refreshAudioButtonsEverywhere(getLang()); };
    }
  } catch(e) {}

  function applyContent(root, lang) {
    var c = CONTENT[lang] || CONTENT.fr;

    var htmlSlots = [
      "def_short", "def_long", "grid_scope_value", "p_intro", "actions", "table_rows",
      "entite_body", "ritual_steps", "moments", "syntony"
    ];

    var imgSlots = ["title_img", "chip_1_img", "chip_2_img"];

    Object.keys(c).forEach(function (key) {
      var el = root.querySelector('[data-po-slot="' + key + '"]');
      if (!el) return;

      if (imgSlots.indexOf(key) > -1) {
        setImg(el, c[key]);
        return;
      }

      if (htmlSlots.indexOf(key) > -1) {
        setHTML(el, c[key]);
        return;
      }

      setText(el, c[key]);
    });

    applyLangbar(root, lang);
    initAudioEverywhere(lang);
  }

  function setLang(lang) {
    var safeLang = normLang(lang) || "fr";
    storeLang(safeLang);
    syncDocumentLang(safeLang);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) {
      applyContent(roots[i], safeLang);
    }

    notifyLocaleChanged();
    return safeLang;
  }

  function bindLangButtons(root) {
    var buttons = root.querySelectorAll("[data-po-lang]");
    for (var i = 0; i < buttons.length; i++) {
      (function (btn) {
        btn.addEventListener("click", function () {
          setLang(btn.getAttribute("data-po-lang"));
        });
      })(buttons[i]);
    }
  }

  function lockTranslation(root) {
    if (!root) return;
    root.setAttribute("translate", "no");
    root.classList.add("notranslate");

    var scope = root.querySelector("[data-po-lex-scope]");
    if (scope) {
      scope.setAttribute("translate", "no");
      scope.classList.add("notranslate");
    }
  }

  function initOne(root) {
    if (!root || root.__poK9CouleurMatiereInit) return;
    root.__poK9CouleurMatiereInit = true;

    lockTranslation(root);
    bindLangButtons(root);
    applyContent(root, getLang());
  }

  function init() {
    syncDocumentLang(getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
    initAudioEverywhere(getLang());
  }

  window.PoK9CouleurMatiereTextsFR_EN_ES_20260318 = {
    init: init,
    getLang: getLang,
    setLang: setLang,
    stopAudio: stopAudio
  };

  window.GoodyTwinLang = window.GoodyTwinLang || {};
  window.GoodyTwinLang.getLang = getLang;
  window.GoodyTwinLang.setLang = setLang;
  window.GoodyTwinLang.init = init;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
